import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

/**
 * Renders the app-wide toast from ToastService. Hosted exactly once, in the dashboard shell,
 * so every routed view shares one toast surface instead of each component owning a copy.
 */
@Component({
  selector: 'app-toast-outlet',
  templateUrl: './toast-outlet.component.html',
})
export class ToastOutletComponent {
  private readonly toastService = inject(ToastService);
  readonly toast = this.toastService.toast;
}
